import React from 'react'
import { FaBars } from 'react-icons/fa'
import { Box, Heading, Button, SimplePopover, Icon } from '@/components/lib'

export default function VerticalNavSystem ({ title, image, banner, nav, body }) {
  return (
    <Box
      bgGradient='to-b'
      gradientFrom='bg.canvas' gradientTo='primary.50'
      _dark={{ gradientFrom: 'bg.canvas', gradientTo: 'primary.950' }}
    >
      {banner}
      <Box display={{ base: 'inherit', md: 'flex' }}>
        {/* Sidebar — transparent so the outer gradient shows through */}
        <Box
          w='180px' minW='180px' minH='100vh'
          display={{ base: 'none', md: 'block' }}
        >
          {image
            ? (
              <Box
                position='relative' w='100%' h='200px'
                style={{ backgroundImage: `url(${image})`, backgroundSize: 'cover', backgroundPosition: 'center center' }}
              >
                <Box
                  bg='linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.6))' h='100%' w='100%'
                  display='flex' justifyContent='end' flexDirection='column'
                >
                  <Heading size='md' color='fg.onAccent' p={2}>{title}</Heading>
                </Box>
              </Box>
              )
            : <Heading size='md' color='fg.default' p={2}>{title}</Heading>}
          {nav}
        </Box>

        <Box flex={1} roundedTopLeft='lg' overflow='clip' shadow='lg' bg='bg.surface'>
          {/* Mobile: collapsed nav in a popover */}
          <Box
            display={{ base: 'flex', md: 'none' }}
            justifyContent='space-between' p={2} alignItems='center'
            borderBottomWidth='1px' borderColor='border.muted'
            bg='bg.surface'
          >
            <Heading size='lg' color='fg.default'>{title}</Heading>
            <SimplePopover
              trigger={<Button size='sm'><Icon as={FaBars} /></Button>}
              body={nav}
            />
          </Box>

          <Box
            p={5} minH='100vh'
            bg='bg.canvas'
          >
            {body}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
